import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISetDatasourceNlpSettingParams {
  id: string;
  nlpOption: string;
}

export class SetDatasourceNlpSettingRequest extends Request<ISetDatasourceNlpSettingParams, IEmptyResult> {
  constructor(params: ISetDatasourceNlpSettingParams) {
    super('setDatasourceNlpSetting', params);
  }
}
